namespace TabAurous.OMS {
    export namespace MetalProductsService {
        export const baseUrl = 'OMS/MetalProducts';

        export declare function List(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<ProductMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "OMS/MetalProducts/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>MetalProductsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
